<template>
    <div class="horizontal">
		<div v-if="systemActive" @click="goToTasks" style="cursor: pointer;" class="horizontal">
            <svg v-if="data[data.column.field] > 0" class="task-icon task-icon--open" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 2h3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3V0h2v2h6V0h2v2zm0 2v2h-2V4H9v2H7V4H5v16h14V4h-2zM7 8h10v2H7V8zm0 4h10v2H7v-2z"/>
            </svg>
            <svg v-else class="task-icon task-icon--none" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 2h3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3V0h2v2h6V0h2v2zm0 2v2h-2V4H9v2H7V4H5v16h14V4h-2z"/>
            </svg>
			<div v-if="systemActive && data[data.column.field] > 0">{{data[data.column.field]}}</div>
		</div>
    <div v-else style="cursor: not-allowed;" class="horizontal">
        <svg class="task-icon task-icon--disabled" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 2h3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3V0h2v2h6V0h2v2zm0 2v2h-2V4H9v2H7V4H5v16h14V4h-2zM7 8h10v2H7V8zm0 4h10v2H7v-2z"/>
        </svg>
    </div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data: {}
		}
	},
    computed: {
        systemActive() {
            return !['Alarms Off', 'No Monitoring'].includes(this.data.systemStatus) && this.data.tasks != null
        }
    },
	methods: {
		goToTasks() {
        this.$router.push({
            name: "systemsTasks",
            params: {
                systemName: this.data.systemName,
                systemId: this.data.id,
                priority: this.data.column.headerText
            },
        });
    },
	},
}
</script>

<style scoped>
/* Ikony jako inline SVG (dawniej Todo*.svg w <img>), żeby kolor szedł z tokenów
   --task-* (assets/css/theme.css): w trybie ciemnym kolory kafelków statusu. */
.task-icon {
    flex: 0 0 auto;
}

.task-icon--open {
    fill: var(--task-open);
}

.task-icon--none {
    fill: var(--task-none);
}

.task-icon--disabled {
    fill: var(--task-disabled);
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/TasksInfoCell.vue